import { Link } from "@tanstack/react-router";

type Props = { kind?: "photographer" | "visagist" };

const perks = [
  {
    t: "Dauerhaft kostenlos",
    d: "Founding Members bleiben für immer gratis gelistet, auch wenn wir später kostenpflichtige Pläne einführen.",
  },
  {
    t: "Founding-Member-Badge",
    d: "Ein sichtbares Abzeichen auf deinem Profil zeigt, dass du von Anfang an dabei warst.",
  },
  {
    t: "Früher Zugang",
    d: "Als Erste:r neue Features testen und Einblicke in Entwicklung und Wachstum der Plattform bekommen.",
  },
];

export function FoundingMemberBanner({ kind = "photographer" }: Props) {
  return (
    <section className="bg-[oklch(0.16_0_0)] text-background border-b border-border">
      <div className="mx-auto max-w-[1100px] px-5 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="eyebrow opacity-60">Limitiert · Startphase</div>
            <h2 className="serif text-4xl md:text-5xl mt-4 leading-[1]">
              Werde <em className="italic">Founding Member</em>
            </h2>
            <p className="mt-6 opacity-70 leading-relaxed max-w-md">
              Die ersten Künstler:innen prägen, wie OM Selected aussieht. Als Dank
              sichern sie sich Vorteile, die es später nicht mehr gibt.
            </p>
            <Link
              to="/apply"
              search={kind === "visagist" ? { as: "visagist" } : undefined}
              className="eyebrow inline-block mt-8 bg-background text-foreground px-6 py-3 hover:opacity-85 transition-opacity"
            >
              Für Frühen Zugang registrieren
            </Link>
          </div>
          <div className="md:col-span-7 md:pl-6 divide-y divide-background/15">
            {perks.map((p) => (
              <div key={p.t} className="py-5 first:pt-0">
                <h3 className="serif text-2xl leading-tight">{p.t}</h3>
                <p className="mt-2 opacity-70 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}